import {usePlaneduHttpService} from "../service/planedu.http.service";
import {FinancialGroupEntity} from "../entity/financial-group.entity";

export function useFinancialGroupRepository() {
    const httpService = usePlaneduHttpService<FinancialGroupEntity>('financial-group');
    return {
        ...httpService,
    }

}